import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { BreadCrumbModel } from '../../models/bread-crumb/bread-crumb.model';
import { BreadCrumbStylingModel } from '../../models/bread-crumb/bread-crumb-styling.model';
import { TemplateService } from '../../services/template-service/template.service';
import { BreadCrumbTemplates } from '../../templates/bread-crumb.template';
import { Router } from '@angular/router';
/**
 * This component refers to a Weather app.
 */
export class CfBreadCrumbComponent extends CfCoreComponent implements OnInit {
/**
 * @param {?} value
 * @return {?}
 */
set links(value: any[]) { this.properties.links = value; }
/**
 * @param {?} value
 * @return {?}
 */
set iconName(value: string) {
    this.properties.icon.name = value;
    this.properties.icon.type = value.startsWith('fa') ? 'fa' : 'mi';
  }

   properties: BreadCrumbModel;

   styling: BreadCrumbStylingModel;
/**
 * @param {?} elementRef
 * @param {?} templateService
 * @param {?} router
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService,
private router: Router) {
    super(elementRef, templateService);
    this.properties = new BreadCrumbModel();
  }
/**
 * <p> This method is called when initializing the component.</p>
 * @return {?}
 */
ngOnInit() {
    super.ngOnInit();
    this.getMyTemplate('bread-crumb', BreadCrumbTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'BREAD-CRUMB').then( sampler => {
        let /** @type {?} */ active = new BreadCrumbStylingModel(this.activeTemplate.style);
        this.styling = Object.assign(active, this.styling);
      // console.log('BREAD-CRUMB', this);
      });
    });
  }
/**
 * @param {?} alias
 * @return {?}
 */
removeAfter(alias) {
    for (let /** @type {?} */ i = this.links.length - 1; i >= 0; i--) {
      if (this.links[i]['alias'] === alias) {
        break;
      } else {
        this.links.splice(i, 1);
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-bread-crumb',
  template: "<div *ngIf=\"_inited && properties?.display\" [class]=\"styling?.container?.class\" [ngClass]=\"getDynamicClasses(styling?.container?.dynamicClass)\"> <nav> <div *ngFor=\"let link of properties?.links; let last = last;let first = first;\" style=\"display:inline-block;\"> <cf-icon *ngIf=\"!first\" style=\"display:inline-block;\" [properties]=\"properties?.icon\" [styling]=\"styling?.iconStyling\"></cf-icon> <a (click)=\"removeAfter(link.alias)\" class=\"link {{styling?.link?.class}}\" routerLinkActive=\"active\" [routerLink]=\"[link.path]\" [ngClass]=\"{'disabled-link':last}\"> {{link.alias}} </a> </div> </nav> </div>",
  styles: [".link { display: inline-block; vertical-align: super; margin: 0; padding: 0; font-family: 'Avenir'; text-decoration: none; color: #757575; } .disabled-link { pointer-events: none; } /deep/ .greyIcon { color: #757575; } .greyLink { color: #757575; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
{type: Router, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'links': [{ type: Input, args: ['links', ] },],
'iconName': [{ type: Input, args: ['iconName', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
};
}

function CfBreadCrumbComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfBreadCrumbComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfBreadCrumbComponent.ctorParameters;
/** @type {?} */
CfBreadCrumbComponent.propDecorators;
/** @type {?} */
CfBreadCrumbComponent.prototype.properties;
/** @type {?} */
CfBreadCrumbComponent.prototype.styling;
/** @type {?} */
CfBreadCrumbComponent.prototype.elementRef;
/** @type {?} */
CfBreadCrumbComponent.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
